import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgAlipayColored({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z"
        fill="#37A0E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.34 16.729c-2.286 0-2.64-1.27-2.68-2.027-.037-.663.418-1.907 2.999-1.907.96 0 2.483.482 4.192 1.186-.966 1.25-2.514 2.748-4.51 2.748zm6.97-3.504c.882-1.667 1.466-3.427 1.466-3.427h-3.401v-1.18h4.192V7.9h-4.192V6h-1.952v1.9H7.231v.718h4.192v1.18H7.897v.632h6.813s-.377 1.144-1.01 2.275c-1.828-.556-3.514-.943-4.868-.943-3.246 0-3.966 1.606-3.813 3.075.124 1.173 1.01 2.884 3.715 2.884 2.47 0 4.466-1.395 5.693-3.056C16.768 15.727 19.241 17.035 21 18v-2.787c-1.86-.628-3.817-1.36-5.69-1.988z"
        fill="#FFFFFE"
      />
      <mask
        id="Alipay_Colored_svg__a"
        maskUnits="userSpaceOnUse"
        x={5}
        y={6}
        width={16}
        height={12}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.34 16.729c-2.286 0-2.64-1.27-2.68-2.027-.037-.663.418-1.907 2.999-1.907.96 0 2.483.482 4.192 1.186-.966 1.25-2.514 2.748-4.51 2.748zm6.97-3.504c.882-1.667 1.466-3.427 1.466-3.427h-3.401v-1.18h4.192V7.9h-4.192V6h-1.952v1.9H7.231v.718h4.192v1.18H7.897v.632h6.813s-.377 1.144-1.01 2.275c-1.828-.556-3.514-.943-4.868-.943-3.246 0-3.966 1.606-3.813 3.075.124 1.173 1.01 2.884 3.715 2.884 2.47 0 4.466-1.395 5.693-3.056C16.768 15.727 19.241 17.035 21 18v-2.787c-1.86-.628-3.817-1.36-5.69-1.988z"
          fill="#fff"
        />
      </mask>
    </svg>
  )
}

export default SvgAlipayColored
